import { t } from 'i18next'

import type { TSituacaoEntregaEmprendimento } from '@/features/empreendimentos/interfaces/empreendimento.enums'
import type { TEstadoCivilEnum } from '@/shared/interfaces/cliente.enums'

export const estadoCivilKeyMap: Record<TEstadoCivilEnum, string> = {
  CivilCasado: t('clientes:estado_civil.casado'),
  CivilDivorciado: t('clientes:estado_civil.divorciado'),
  CivilSolteiro: t('clientes:estado_civil.solteiro'),
  CivilUniaoEstavel: t('clientes:estado_civil.uniao_estavel'),
  CivilViuvo: t('clientes:estado_civil.viuvo'),
  CivilSeparadoJudicialmente: t('clientes:estado_civil.separado_judicialmente'),
}

export const situacaoEntregaKeyMap: Record<TSituacaoEntregaEmprendimento, string> = {
  EmConstrucao: t('enums:empreendimentos.em_construcao'),
  Lancamento: t('enums:empreendimentos.lancamento'),
  EmBreve: t('enums:empreendimentos.em_breve'),
  ProntoParaMorar: t('enums:empreendimentos.pronto_para_morar'),
  Entregue: t('enums:empreendimentos.entregue'),
} as const
